import { Table } from "antd";
import React from "react";

// Build columns from weldParameters.header
function buildColumns(header) {
  const columns = [
    {
      title: "",
      dataIndex: "parameter",
      key: "parameter",
      fixed: "left",
      width: 200,
      className: "parameter-column",
      render: (text, record) => (
        <div
          className="parameter-column-text"
          style={{
            color: record.isHeader ? "#e03540" : "inherit",
            fontWeight: record.isHeader ? "bold" : "normal",
            textAlign: "left",
            paddingLeft: record.isHeader ? "10px" : "10px",
          }}
        >
          {text}
        </div>
      ),
      onCell: (record) => {
        if (record.isHeader) return { colSpan: 1 };
        return {};
      },
    },
  ];

  header.forEach((zone, idx) => {
    const zoneKey = Object.keys(zone)[0];
    const subColumns = zone[zoneKey];
    columns.push({
      title: (
        <div className="header-title" style={{ color: "#e03540" }}>
          {zoneKey}
        </div>
      ),
      children: subColumns.map((subCol, subIdx) => ({
        title: (
          <div className="header-lead" style={{ color: "#e03540" }}>
            {subCol}
          </div>
        ),
        dataIndex: [`zone_${idx}`, subIdx],
        key: `zone_${idx}_${subCol}`,
        width: 120,
        align: "center",
        render: (value) => value,
        onCell: (record) => {
          if (record.isHeader) return { colSpan: 0 };
          return {};
        },
      })),
    });
  });

  return columns;
}

// Build dataSource from weldParameters.values and header
function buildDataSource(values, header) {
  let dataSource = [];
  let keyCounter = 1;

  Object.entries(values).forEach(([section, params]) => {
    // Section header row
    dataSource.push({
      key: `header-${keyCounter++}`,
      parameter: section,
      isHeader: true,
    });

    params.forEach((paramObj) => {
      const paramName = Object.keys(paramObj)[0];
      if (
        paramName === "Pass Name By Group" ||
        paramName === "Pass Pendant Name By Group"
      )
        return; // filter out
      const paramValue = paramObj[paramName];

      // Handle value with unit (array: [{Unit: "X"}, [values...]])
      let unit = "";
      let valuesArray = [];
      if (
        Array.isArray(paramValue) &&
        paramValue.length === 2 &&
        typeof paramValue[0] === "object"
      ) {
        unit = Object.values(paramValue[0])[0];
        valuesArray = paramValue[1];
      } else if (Array.isArray(paramValue)) {
        valuesArray = paramValue;
      } else {
        valuesArray = [paramValue];
      }

      // Build row with values for each zone and subcolumn
      let row = {
        key: keyCounter++,
        parameter: paramName + (unit ? ` (${unit})` : ""),
      };

      let valueIdx = 0;
      header.forEach((zone, zoneIdx) => {
        const subColumns = zone[Object.keys(zone)[0]];
        row[`zone_${zoneIdx}`] = [];
        subColumns.forEach(() => {
          row[`zone_${zoneIdx}`].push(
            valuesArray[valueIdx] !== undefined ? valuesArray[valueIdx] : ""
          );
          valueIdx++;
        });
      });

      dataSource.push(row);
    });
  });

  return dataSource;
}

const WeldParameters = ({ weldParameters }) => {
  const columns = buildColumns(weldParameters.header);
  const dataSource = buildDataSource(
    weldParameters.values,
    weldParameters.header
  );

  const calcHeight = -240;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;

  return (
    <div
      className="weld-parameters-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
        className="welding-parameters-table"
        scroll={{ x: "max-content", y: tableHeight }}
      />
    </div>
  );
};

export default WeldParameters;
